import Vue from 'vue';
import {
  URLParams,
  MakeGraphQLQuery,
  updateDropdownSelectedValue,
} from '../utils/helpers';

const BlogTemplate = () => {
  if (!$('#blog_filter_dropdown').length) {
    return false;
  }

  let params;
  let queryString;
  let allBlogPosts;
  let getBlogType;
  let queryStringContentType = URLParams('content');
  let isBlogFilterTemplate = false;
  let blogArticleFilterComponent;

  // Check if the Blog Filter Template
  // =================================
  if ($('#article-grid-container').length) {
    isBlogFilterTemplate = true;
  }

  // Raw GraphQL Query
  // =================
  // The Graph QL Query: query:"handle:${blogHandle}"
  // The second Graph QL Query:  query:"tag:${articleTag}"
  const graphQLBlogArticleQuery = (blogHandle, articleTag) => {
    return `{
      blogs(query:"handle:${blogHandle}", first: 1) {
        edges {
          node {
            articles(query:"tag:'${articleTag}'", first: 50) {
              edges {
                node {
                  id
                  title
                  excerpt(truncateAt: 100)
                  content(truncateAt: 100)
                  handle
                  onlineStoreUrl
                  tags
                  image {
                    originalSrc
                    transformedSrc
                    altText
                  }
                }
              }
            }
          }
        }
      }
    }`;
  };

  // Filter Blog Posts By Tags
  // =========================
  $(document).ready(function () {
    // Set Default Local Storage if Null
    // =================================
    if (queryStringContentType == null) {
      window.localStorage.setItem('blogType', 'women');
    } else {
      window.localStorage.setItem('blogType', queryStringContentType);
    }

    // Update Get Blog Type Variable
    // =============================
    getBlogType = window.localStorage.getItem('blogType');

    // Update Window PushState
    // =======================
    window.history.pushState({}, '', `?content=${getBlogType}`);

    // Update Dropdown
    // ===============
    updateDropdownSelectedValue('blog-filter-dropdown', getBlogType);

    // Update the Blog Page based on the Dropdown
    // ==========================================
    $('#blog_filter_dropdown').on('change', function () {
      let filterVal = $(this).val();

      // Need To Push Params to the Array when Button Clicked
      params = ['content=' + filterVal];

      if (params.length > 1) {
        queryString = params.join('&');
      } else {
        queryString = params[0];
      }
      window.localStorage.setItem('blogType', filterVal);
      window.location.href =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?' +
        queryString;
    });

    // Update Blog Navigation
    // ======================

    // Note: Strip any Query String's coming from the Shopify LinkList
    //       'advice-support-footer-menu'
    let links = $('.blog-navigation-banner__navbar__link');
    links.each(function () {
      let link = $(this);
      let url = link.attr('href');
      url = url.split('?')[0]; // Strip existing Query String
      let updatedLink = `${url}?content=${getBlogType}`;
      $(this).attr('href', updatedLink);
    });

    // Update the Article Cards
    // =======================
    if (!isBlogFilterTemplate) {
      let articles = $(
        '.article-grid__content .article-card--large, .article-grid__content .article-card--small'
      );
      let numberOfHiddenArticles = 0;
      let numberOfArticles = 0;
      articles.each(function (index) {
        let article = $(this);
        let articleTypes = article.data('type').split(';');
        if (!articleTypes.includes(getBlogType)) {
          article.addClass('incorrect-type');
          numberOfHiddenArticles++;
        }
        numberOfArticles++;
      });
      if (numberOfHiddenArticles >= numberOfArticles) {
        $('.article-grid__no-results').removeClass('hide');
      }
    }

    // FadeIn Blog Articles Container
    // ==============================
    if (!isBlogFilterTemplate) {
      window.addEventListener('DOMContentLoaded', (event) => {
        $('.article-card--skeleton').fadeOut('fast').remove();
        $(
          '.article-grid-overlay-container .article-card:not(.article-card--skeleton):not(.incorrect-type)'
        ).removeClass('hide');
        $('.article-grid-overlay-container .article-grid__content').fadeTo(
          'fast',
          1
        );
      });
    }

    // GraphQL API Call
    // ================
    if (isBlogFilterTemplate) {
      MakeGraphQLQuery(
        `${window.theme.storeURL}/api/2026-04/graphql.json`,
        graphQLBlogArticleQuery(
          'understanding-incontinence',
          `client:${getBlogType}`
        )
      )
        .then((response) => {
          // Construct New Object
          // To Pass to VueJS Component
          // ==========================
          let queriedArticles = [];

          let articles = response.data.blogs.edges[0].node.articles.edges;

          for (const article of articles) {
            let articleCard = {
              id: article.node.id,
              handle: article.node.handle,
              title: article.node.title,
              tags: article.node.tags,
              url: article.node.onlineStoreUrl,
              excerpt: article.node.excerpt,
              content: article.node.content,
              image: article.node.image.originalSrc,
            };

            // Push new Products to Array
            queriedArticles.push(articleCard);
          }

          // Update Vue JS Component
          blogArticleFilterComponent.updateArticles(queriedArticles);
          allBlogPosts = [...queriedArticles];
        })
        .then(() => {
          if (blogArticleFilterComponent.blogArticles.length > 1) {
            $('.sm-article-card--skeleton').fadeOut('fast').remove();
            $(
              '#article-grid-container .sm-article-card:not(.sm-article-card--skeleton)'
            ).fadeTo('fast', 1);
            $('#article-grid-container .article-grid__content').fadeTo(
              'fast',
              1
            );
          }
        })
        .catch((err) => console.error('ERROR', err));
    }
  });

  // VUE JS APP
  // ====================
  if (isBlogFilterTemplate) {
    let ArticleCardComponent = {
      name: 'article-card-component',
      template: '#article-card-template',
      props: ['url', 'title', 'excerpt', 'content', 'image'],
    };

    blogArticleFilterComponent = new Vue({
      el: '#article-grid-container',
      components: {
        'article-card': ArticleCardComponent,
      },
      data: function () {
        return {
          blogArticles: [],
          ActiveFilter: 1,
        };
      },
      methods: {
        updateArticles: function (articles) {
          this.blogArticles = [...articles];
        },
        filterArticles: function (filterValue) {
          $('#article-grid-container .article-grid__content').fadeTo(
            'fast',
            0.4
          );

          setTimeout(() => {
            let selectTag = `blog_filter:${filterValue}`;
            let originalBlogArticles = allBlogPosts;

            if (filterValue == 'all') {
              this.blogArticles = originalBlogArticles;
              this.checkforNoResults();
            } else {
              let filteredArr = originalBlogArticles.filter((article) =>
                article.tags.includes(selectTag)
              );

              this.blogArticles = filteredArr;
              this.checkforNoResults();
            }

            $('#article-grid-container .article-grid__content').fadeTo(
              'fast',
              1
            );
            return this.blogArticles;
          }, 250);
        },
        handleActiveFilter: function (id) {
          this.ActiveFilter = id;
        },
        checkforNoResults: function () {
          if (this.blogArticles.length < 1) {
            $('.article-grid__no-results').removeClass('hide');
          } else {
            $('.article-grid__no-results').addClass('hide');
          }
        },
      },
    });
  }
};
export default BlogTemplate;
